export default __webpack_public_path__ + "static/media/igo.a60d426c.svg";